import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import MainPage from '../src/components/MainPage';
import Layout from '../src/components/Layout';
import { config } from '../src/constants/config';

const Index = ({ data }) => (
  <Layout>
    <MainPage data={data.acf} />
  </Layout>
);

Index.getInitialProps = async () => {
  const { data } = await axios.get(`${config.wp}/7`);
  return { data };
};

Index.propTypes = {
  data: PropTypes.object,
};

export default Index;
